import { RefObject, useEffect } from "react";

export const PAUSE_OTHER_MEDIA_EVENT = "pause-other-media";

export function usePauseOtherMedia(mediaRef: RefObject<HTMLMediaElement | null>) {
    useEffect(() => {
        const handler = (event: Event) => {
            const customEvent = event as CustomEvent<HTMLMediaElement>;

            if (mediaRef.current && customEvent.detail !== mediaRef.current) {
                mediaRef.current.pause();
            }
        };

        window.addEventListener(PAUSE_OTHER_MEDIA_EVENT, handler);
        return () =>
            window.removeEventListener(PAUSE_OTHER_MEDIA_EVENT, handler);
    }, [mediaRef]);

    return () => {
        if (!mediaRef.current) return;

        window.dispatchEvent(
            new CustomEvent(PAUSE_OTHER_MEDIA_EVENT, {detail: mediaRef.current})
        );
    };
}